import React, { useEffect, useState } from "react";
import { usePortal } from "../Providers/PortalProvider";
import SessionExpiredDialog from "../Webshop/Desktop/Pages/Checkout/Components/SessionExpiredDialog";
import ExpiredTermsOfServiceDialog from "../Webshop/Desktop/Pages/Checkout/Components/ExpiredTermsOfServiceDialog";
import UpdateMobilePhoneDialog from "../Webshop/Components/UpdateMobilePhoneDialog";
import NetlifeConsentSettingsDialog from "../Webshop/Mobile/Components/NetlifeConsentSettingsDialog";
import { useAuth } from "../Webshop/providers/AuthProvider";
import { usePictureSets } from "@/react/Webshop/hooks/usePictureSets";
import SetSubjectNameDialog from "@/react/Webshop/Components/SetSubjectNameDialog";
import { NETLIFE_CONSENT_SETTINGS_EVENT, isNetlifeConsentSettingsEvent, } from "../../../apps/webshop/assets/Analytics/ConsentProviders/NetlifeConsentProvider";
const DisplayDialogs = () => {
    var _a, _b;
    const state = useAuth();
    const { showSetNameDialog } = usePictureSets();
    const [closedDialogs, setClosedDialogs] = useState(getInitialClosedDialogs());
    const [netlifeConsentProvider, setNetlifeConsentProvider] = useState(null);
    useEffect(() => {
        const handler = (event) => {
            if (isNetlifeConsentSettingsEvent(event)) {
                setNetlifeConsentProvider(event.detail.provider);
            }
        };
        window.addEventListener(NETLIFE_CONSENT_SETTINGS_EVENT, handler);
        return () => window.removeEventListener(NETLIFE_CONSENT_SETTINGS_EVENT, handler);
    }, []);
    const portal = usePortal();
    const smsEnabled = portal.options.smsEnabled;
    const onClose = (dialog, uuid) => () => {
        setClosedDialogs((prev) => {
            if (dialog === "set_yearbook_pose" && uuid) {
                return Object.assign(Object.assign({}, prev), { set_yearbook_pose: Object.assign(Object.assign({}, (prev.set_yearbook_pose || {})), { [uuid]: true }) });
            }
            return Object.assign(Object.assign({}, prev), { [dialog]: true });
        });
    };
    useEffect(() => {
        if (!state.isAuthenticated) {
            setClosedDialogs(getInitialClosedDialogs());
        }
    }, [state]);
    useEffect(() => {
        sessionStorage.setItem("auth_provider_closed_dialogs", JSON.stringify(closedDialogs));
    }, [closedDialogs]);
    if (state.sessionExpired) {
        return React.createElement(SessionExpiredDialog, null);
    }
    if ((_a = state.user) === null || _a === void 0 ? void 0 : _a.termsOfServiceExpired) {
        return React.createElement(ExpiredTermsOfServiceDialog, null);
    }
    if (netlifeConsentProvider) {
        return (React.createElement(NetlifeConsentSettingsDialog, { provider: netlifeConsentProvider, onClose: () => setNetlifeConsentProvider(null) }));
    }
    if (state.isAuthenticated &&
        state.user !== null &&
        !((_b = state.user) === null || _b === void 0 ? void 0 : _b.mobilePhone) &&
        smsEnabled &&
        !closedDialogs["update_mobile_dialog"]) {
        return (React.createElement(UpdateMobilePhoneDialog, { onClose: onClose("update_mobile_dialog") }));
    }
    if (showSetNameDialog) {
        return React.createElement(SetSubjectNameDialog, null);
    }
    return null;
};
const getInitialClosedDialogs = () => {
    const closedDialogs = sessionStorage.getItem("auth_provider_closed_dialogs");
    if (!closedDialogs) {
        return {};
    }
    const info = JSON.parse(closedDialogs);
    return {
        update_mobile_dialog: !!info["update_mobile_dialog"],
    };
};
export default DisplayDialogs;
